import { BugOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

import type { ApiErrorDetail } from '@/types'

import cn from './ApiErrorContent.module.scss'

export interface ApiErrorProductInfo {
  description?: string
  article?: string
  brandName?: string
  storeName?: string
}

type ApiErrorContentProps = {
  message: string
  details: ApiErrorDetail[]
  traceId?: string
  productInfo?: ApiErrorProductInfo
}

function ApiErrorContent({
  message,
  details,
  traceId,
  productInfo,
}: ApiErrorContentProps) {
  return (
    <div className={cn.container}>
      <ExclamationCircleOutlined className={cn.icon} />

      <div className={cn.body}>
        <div className={cn.title}>Внимание! Произошла ошибка</div>

        <div className={cn.messageBox}>
          <span className={cn.message}>{message}</span>
        </div>
      </div>

      {details.length > 0 && (
        <div className={cn.details}>
          <div className={cn.detailsTitle}>
            <BugOutlined /> Технические подробности:
          </div>
          {details.map((detail, index) => (
            <div key={index} className={cn.detail}>
              <div className={cn.detailMessage}>
                {detail.message || 'Описание отсутствует'}
              </div>

              {detail.context && (
                <div className={cn.context}>
                  {productInfo?.description ? (
                    <>
                      <div className={cn.productName}>
                        {productInfo.description}
                      </div>
                      <div className={cn.productMeta}>
                        {productInfo.article && (
                          <>
                            <span className={cn.productMetaLabel}>
                              Артикул:
                            </span>{' '}
                            <strong>{productInfo.article}</strong>
                          </>
                        )}
                        {productInfo.brandName && (
                          <>
                            {' '}
                            •{' '}
                            <span className={cn.productMetaLabel}>
                              Бренд:
                            </span>{' '}
                            <strong>{productInfo.brandName}</strong>
                          </>
                        )}
                        {productInfo.storeName && (
                          <>
                            {' '}
                            •{' '}
                            <span className={cn.productMetaLabel}>
                              Склад:
                            </span>{' '}
                            <strong>{productInfo.storeName}</strong>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className={cn.rawContext}>
                      <b>Поставщик:</b> {detail.context.key.supplierId} |{' '}
                      <b>Склад:</b> {detail.context.key.storeCode} |{' '}
                      <b>Товар:</b> {detail.context.key.productCode}
                    </div>
                  )}
                </div>
              )}

              {detail.field && (
                <div className={cn.field}>
                  Поле: <code className={cn.fieldName}>{detail.field}</code>
                  {detail.rejectedValue !== undefined &&
                    ` (значение: ${String(detail.rejectedValue)})`}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {!!traceId && <div className={cn.traceId}>TraceID: {traceId}</div>}
    </div>
  )
}

export default ApiErrorContent
